import { render } from "./update-pot-salary-interval.vue?vue&type=template&id=6ed3a66f&scoped=true"
import script from "./update-pot-salary-interval.vue?vue&type=script&lang=js"
export * from "./update-pot-salary-interval.vue?vue&type=script&lang=js"

import "./update-pot-salary-interval.vue?vue&type=style&index=0&id=6ed3a66f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed3a66f"],['__file',"src/components/applications/wagesetting/update/update-pot-salary-interval.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ed3a66f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ed3a66f', __exports__)) {
    api.reload('6ed3a66f', __exports__)
  }
  
  module.hot.accept("./update-pot-salary-interval.vue?vue&type=template&id=6ed3a66f&scoped=true", () => {
    api.rerender('6ed3a66f', render)
  })

}


export default __exports__